module.exports = __webpack_public_path__ + "static/hasan-1bfb778c6bff129b8d8ef673d0c106dc.png";